import React, { useEffect, useState, useCallback } from "react";
import API_BASE_URL from "../../API/ConfigAPI";
import StatistiqueStatut from "../../components/StatistiqueStatut/StatistiqueStatut";
import BarreNavigation from "../../components/BarreNavigation/BarreNavigation";
import Navbarhorizontal from "../../components/Navbarhorizontal/Navbarhorizontal";
import StatistiqueEnvoiMail from "../../components/StatistiqueEnvoiMail/StatistiqueEnvoiMail";
import StatistiqueEnvoiMailMois from "../../components/StatistiqueEnvoiMailMois/StatistiqueEnvoiMailMois";
import StatistiquePrestation from "../../components/StatistiquePrestation/StatistiquePrestation";
import StatistiqueCAGestionnaire from "../../components/StatistiqueCAGestionnaire/StatistiqueCAGestionnaire";
import ChiffresCles from "../../components/ChiffresCles/ChiffresCles";
import EvolutionCA from "../../components/EvalutionCA/EvalutionCA";
import EvolutionPortefeuille from "../../components/EvolutionPortefeuille/EvolutionPortefeuille";
import "./statiquespage.css";

const monthNames = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];
const StatistiquesPage = () => {
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  const currentYear = today.getFullYear();
  const [facturations, setFacturations] = useState([]);
  const [selectedMonthIndex, setSelectedMonthIndex] =
    useState(currentMonthIndex);

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [keyFigures, setKeyFigures] = useState({
    totalCA: 0,
    nbFactures: 0,
    topGestionnaire: "",
  });
  const [caMonthlyData, setCaMonthlyData] = useState([]);
  // eslint-disable-next-line
  const [totalFacturations, setTotalFacturations] = useState(0); // Ajoutez cette ligne

  const [portefeuilleData, setPortefeuilleData] = useState([]);

  const selectedMonth = `${selectedYear}-${String(
    selectedMonthIndex + 1
  ).padStart(2, "0")}`;

  const selectedMonthDisplay = `${monthNames[selectedMonthIndex]}-${selectedYear}`;
  const handleMonthChange = (e) =>
    setSelectedMonthIndex(Number(e.target.value));
  const handleYearChange = (e) => setSelectedYear(Number(e.target.value));

  useEffect(() => {
    const fetchFacturations = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${API_BASE_URL}/home/api/facturations/`, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des données");
        }

        const data = await response.json();
        setFacturations(data);
        calculateCAMonthly(data);
        updateMonthlyStatistics(data);
        calculatePortfolioData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
    };

    fetchFacturations();
    // eslint-disable-next-line
  }, [selectedMonth]);

  const handleTotalFacturationsChange = useCallback((total) => {
    setTotalFacturations(total); // Utilisez cette fonction pour mettre à jour totalFacturations
  }, []);

  const handleDataCalculate = useCallback((data) => {
    //console.log("Data Calculated in StatistiquesPage:", data);
    setKeyFigures((prev) => ({
      ...prev,
      totalCA: data.totalCA,
      topGestionnaire: data.topGestionnaire,
    }));
  }, []);

  const calculateCAMonthly = (facturations) => {
    const caByMonth = facturations.reduce((acc, fact) => {
      if (fact.statut === "Terminé") {
        // Only include facturations with status "Terminé"
        const monthYear = fact.mois_facturation;
        const ca = parseFloat(fact.total_ttc.toFixed(2)); // Arrondir à deux chiffres après la virgule

        if (acc[monthYear]) {
          acc[monthYear] += ca;
        } else {
          acc[monthYear] = ca;
        }
      }
      return acc;
    }, {});

    const formattedData = Object.entries(caByMonth).map(([month, ca]) => ({
      month,
      ca,
    }));

    setCaMonthlyData(formattedData);
  };

  const calculatePortfolioData = (facturations) => {
    const dataByMonth = facturations.reduce((acc, fact) => {
      const [monthName, year] = fact.mois_facturation.split("-"); // ✅ inversé

      const key = `${monthName}-${year}`; // reste inchangé

      if (!acc[key]) {
        acc[key] = { nbCompanies: new Set(), nbFactures: 0 };
      }

      acc[key].nbCompanies.add(fact.siret);

      if (fact.statut === "Terminé") {
        acc[key].nbFactures++;
      }

      return acc;
    }, {});

    const formatted = Object.entries(dataByMonth).map(([month, val]) => ({
      month,
      nbCompanies: val.nbCompanies.size,
      nbFactures: val.nbFactures,
    }));

    setPortefeuilleData(formatted);
  };

  const updateMonthlyStatistics = (data) => {
    const nb = data.filter(
      (f) => f.statut === "Terminé" && f.mois_facturation === selectedMonth
    ).length;
    setKeyFigures((prev) => ({ ...prev, nbFactures: nb }));
    console.log("Filtrage nbFactures pour :", selectedMonth);
    console.log(
      "Matching factures :",
      data.filter(
        (f) => f.statut === "Terminé" && f.mois_facturation === selectedMonth
      )
    );
  };

  //console.log("Rendering StatistiquesPage with keyFigures:", keyFigures);
  const availableYears = Array.from({ length: 6 }, (_, i) => currentYear - i);
  return (
    <div className="parent-layout-statiquestatut">
      <BarreNavigation />
      <div className="content-statiquespage">
        <Navbarhorizontal />
        <h1>Le tableau de bord</h1>
        <p className="soustitle">
          La synthèse des données de facturation du mois de{" "}
          {selectedMonthDisplay.charAt(0).toUpperCase() +
            selectedMonthDisplay.slice(1)}
        </p>
        <div className="choisi-mois">
          <div className="group-choix">
            <label className="mois" htmlFor="mois">
              Mois :
            </label>
            <select
              id="mois"
              onChange={handleMonthChange}
              value={selectedMonthIndex}
            >
              {monthNames.map((month, idx) => (
                <option key={month} value={idx}>
                  {month}
                </option>
              ))}
            </select>
          </div>
          <div className="group-choix">
            <label className="mois" htmlFor="annee">
              Année :
            </label>
            <select id="annee" onChange={handleYearChange} value={selectedYear}>
              {availableYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="containair-Statistiqes">
          <StatistiqueStatut
            facturations={facturations}
            selectedMonth={selectedMonth}
            onTotalFacturationsChange={handleTotalFacturationsChange}
          />
          <StatistiqueEnvoiMail
            facturations={facturations}
            selectedMonth={selectedMonth}
          />
          <StatistiqueEnvoiMailMois
            facturations={facturations}
            selectedMonth={selectedMonth}
          />
          <StatistiquePrestation
            facturations={facturations}
            selectedMonth={selectedMonthDisplay}
          />
          <StatistiqueCAGestionnaire
            facturations={facturations}
            selectedMonth={selectedMonthDisplay}
            onDataCalculate={handleDataCalculate}
          />
          <ChiffresCles
            totalCA={keyFigures.totalCA}
            topGestionnaire={keyFigures.topGestionnaire}
            facturations={facturations}
            selectedMonth={selectedMonth}
          />

          <EvolutionCA
            data={caMonthlyData.filter((item) =>
              item.month.includes(selectedYear)
            )}
          />
          <EvolutionPortefeuille
            data={portefeuilleData}
            selectedYear={selectedYear}
          />
        </div>
      </div>
    </div>
  );
};

export default StatistiquesPage;
